import './styles.css';
import Nav from './components/Nav';
import ReactRouter from './components/ReactRouter';
import Footer from './components/Footer';


function App() {
  return (
    <>
      <ReactRouter/>
      <Footer/>
    </>  
  );
}

export default App;
